/**
 * Test IDs for QA automation.
 */
export const testIds = {
  userSelectUsersPicker: "user-select-users-picker",
  userSelectUsersSearch: "user-select-users-search",
} as const;
